/**
 * The surface focus boxes are laid out in, in window pixels. The desktop app
 * uses this display's work area, because focus stays on one display even
 * while the Workspace spans the desktop. The browser uses the element marked
 * `data-focus-surface`, else the canvas viewport, else the window.
 */
import { getCanvasViewportDimensions } from "@/lib/viewport-dimensions";
import {
  calculateFocusSurfaceBox,
  type FocusWindowBox,
} from "@/lib/focus-window-layout";
import { isTauri } from "@/lib/is-tauri";

function workAreaDimension(value: unknown, fallback: number): number {
  return typeof value === "number" && Number.isFinite(value) && value > 0
    ? value
    : fallback;
}

/** The browser's focus surface: the element marked `data-focus-surface`,
 *  else the canvas viewport, else the window. */
export function focusSurfaceViewport() {
  return getCanvasViewportDimensions(
    typeof document !== "undefined"
      ? document.querySelector("[data-focus-surface]")
      : null,
  );
}

export function currentFocusSurfaceBox(): FocusWindowBox {
  if (isTauri()) {
    return calculateFocusSurfaceBox({
      width: workAreaDimension(
        window.__DENKER_WORK_AREA_WIDTH__,
        window.innerWidth,
      ),
      height: workAreaDimension(
        window.__DENKER_WORK_AREA_HEIGHT__,
        window.innerHeight,
      ),
    });
  }
  const { viewportWidth, viewportHeight } = focusSurfaceViewport();
  return calculateFocusSurfaceBox({
    width: viewportWidth,
    height: viewportHeight,
  });
}
